import React from 'react';
import dayjs from 'dayjs';
import { gql, useMutation, useQuery } from '@apollo/client';
import { AssessmentSessionNotificationsList } from '../AssessmentSessionNotificationsList/assessment-session-notifications-list.component';

const GET_UPCOMING_NOTIFICATIONS = gql`
  query GetAssessmentSessionUpcomingNotifications($_id: ID!) {
    assessmentSession(_id: $_id) {
      _id
      upcomingNotifications {
        sentAt
        scheduledAt
        type
      }
    }
  }
`;

const CANCEL_UPCOMING_NOTIFICATION = gql`
  mutation CancelUpcomingNotification($_id: ID!, $scheduledAt: String!) {
    cancelNotification(_id: $_id, scheduledAt: $scheduledAt)
  }
`;

interface IAssessmentSessionUpcomingNotificationsGraphQL {
  assessmentSessionId: string;
}

const AssessmentSessionUpcomingNotificationsGraphQL: React.FC<IAssessmentSessionUpcomingNotificationsGraphQL> = ({ assessmentSessionId }) => {
  const [cancelNotification] = useMutation(CANCEL_UPCOMING_NOTIFICATION);
  const { data, refetch } = useQuery(GET_UPCOMING_NOTIFICATIONS, {
    variables: { _id: assessmentSessionId },
    fetchPolicy: 'cache-and-network'
  });

  const notifications = data?.assessmentSession && data.assessmentSession.upcomingNotifications;
  const handleCancelNotification = (notification: string) => {
    if (window.confirm(`Are you sure you want to cancel the notification on ${dayjs(new Date(notification)).format('YYYY/MM/DD @ h:mm A')}?`)) {
      cancelNotification({
        variables: {_id: assessmentSessionId, scheduledAt: notification }
      })
        .then(() => refetch());
    }
  }

  return <AssessmentSessionNotificationsList cancelNotification={handleCancelNotification} notifications={notifications} />
};

export default AssessmentSessionUpcomingNotificationsGraphQL;
